import { Component, OnInit } from '@angular/core';
import IdleTimer from './IdleTimer';
import { Router } from '@angular/router';
import { AuthenticationService } from './shared/services/authentication/authentication.service';
import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { TokenTimerService } from '../app/shared/services/authentication/token-timer.service'; 
import { AuthenticationManager } from './shared/services/authentication/authenticationManager';

@Component({
    selector: 'app-root',
    template: `
        <app-token-popup
            *ngIf="showPopup"
            (stayLoggedIn)="refreshUserToken()"
            (autoLogout)="logout()"
        ></app-token-popup>

        <router-outlet></router-outlet>
    `,
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    showPopup = false;
    timer: any;

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private titleService: Title,
        private tokenService: TokenTimerService,
        private authenticationManager: AuthenticationManager
    ) {
        this.titleService.setTitle(environment.applicationName);
    }

    ngOnInit() {
        this.tokenService.popupEvent.subscribe(() => {
            if (this.router.url !== '/login') {
                this.showPopup = true;
            }
        });

        this.timer = new IdleTimer({
            timeout: '600', // 10 min
            onTimeout: () => {
                if (this.router.url === '/login') return; 

                this.showPopup = true;
                setTimeout(() => {
                    if (this.showPopup) {
                        this.logout();
                    }
                }, 30000);
            }
        });
    }

    refreshUserToken() {
        const auth = this.authenticationManager.getAuthenticate();
        const refreshRequest = {
            token: auth?.token,
            userId: auth?.userId
        };

        this.authenticationService.refreshToken(refreshRequest).subscribe({
            next: (response) => {
                console.log('✅ Token refreshed successfully!');
                this.showPopup = false;
            },
            error: (err) => {
                console.error('❌ Refresh token failed:', err);
                this.logout();
            }
        });
    }

    logout() {
        this.tokenService.cancelPopup();

        sessionStorage.clear();
        localStorage.clear();
        this.updateLogoutAudit('SESSION_TIMEOUT');
        this.router.navigate(['/login']);

        setTimeout(() => {
            location.reload();
        }, 200);
    }

    updateLogoutAudit(logoutMode: any) {
        this.authenticationService.updateLogoutAudit(logoutMode).subscribe({
            next: () => {},
            error: () => {}
        });
    }
}
